import React from "react";
import Navbar from "../inc/Navbar";
import "./Coding.css";
import { Link } from "react-router-dom";
import Html from "../images/html.jpg";
import Css from "../images/css.jpg";
import JS from "../images/js.jpg";
import Reactjs from "../images/react.jpg";
import NodeJS from "../images/nodejs.jpg";
import ScrollToTop from "react-scroll-to-top";
import Firebase from "../images/firebase.jpg";
function Coding() {
    return (
        <>
            <Navbar />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="Gray" />
            <div style={{ color: "Gray", padding: "14px;" }} className="fixed-bottom "> <a href="tel: +91 9933798896" className="btn btn-primary" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
                <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
                <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
            </svg>  Call Us <div className="spinner-grow text-light spinner-grow-sm" role="status">
                    <span className="visually-hidden"> Loading...</span>
                </div> </a></div>

            <div className="d-flex justify-content-end">


            </div>

            <div className="umastyle">
                <br />
                <br />
                <br />
                <br /> <br />


                <div className="album py-1">

                    <div className="container">

                        <div className="row">
                            <h1 style={{ fontSize: "2rem", color: "white" }} className="card-text mb-2 "> <b>MR. INDIAN CODER </b> ACADEMY Join <Link to="/application"> <button className="btn btn-light btn-sm">Apply</button></Link></h1>
                            <h5 className="blink" >Ghar Ghar Software Engineer, Ghar Ghar Startup</h5>
                            <br />
                            <br />
                            <br />


                        </div>
                    </div>
                </div>
            </div>
            <div className="codingacademy">

                <div className="album py-3">

                    <div className="container">

                        <div className="row">
                            <br />
                            <h2 style={{ color: "white" }} className="card-text mb-5"> <b>Full Stack Website Development</b></h2>
                            <h5 className="card-text mb-5">With Live Website Guarantee*</h5>
                            <h5 className="card-text mb-4">Master's Program</h5>
                            <h5 className="card-text mb-5">Ranked #1 Best Coding Course By Mr. Indian Coder</h5>
                            <div className="col-md-5 ">
                                <div className="card text-dark bg-light mb-3">
                                    <center>
                                        <div style={{ color: "dark" }} className="card-header"><h6> Course Starts: An update will be available soon. </h6>
                                            <p >Limited no. of seats available</p></div>

                                        <div className="card-body">
                                            <h6 className="card-title">Program Duration: 12 Months</h6>
                                            <p className="card-title">At 08-10 hourse/week</p>
                                            <hr />
                                            <h6 className="card-title">Offline Coding Course</h6>
                                            <p className="card-title">Learning in your city / home</p>

                                            <hr />
                                            <h6 className="card-title">Education Qualification</h6>
                                            <p className="card-title">Class Start V (no age limit & No qualification bar)</p>


                                        </div>
                                    </center>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <center><h5 style={{ color: "Gray" }}>The languages ​​that will be taught</h5></center>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-8" >




                            <h6 className="card-text"> <b>HTML</b></h6>
                            <p className="card-text">The HyperText Markup Language, HTML (Programming language)</p>

                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <br />
                        <div className="col-md-6 mt-8" >

                            <img src={Html} className="card-img-top" alt="Html" />


                            <div className="d-flex justify-content-between align-items-center">



                            </div>

                        </div>






                    </div>


                </div>

            </div>
            <hr />
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-8" >


                            <img src={Css} className="card-img-top" alt="Css" />

                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <div className="col-md-5 mt-6" >

                            <h6 className="card-text"> <b>CSS</b></h6>
                            <p className="card-text">
                                Cascading Style Sheets is a style sheet language</p>


                            <div className="d-flex justify-content-between align-items-center">

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-8" >




                            <h6 className="card-text"> <b>JS</b></h6>
                            <p className="card-text">JavaScript is a Programming language

                            </p>

                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <br />
                        <div className="col-md-6 mt-8" >

                            <img src={JS} className="card-img-top" alt="JS" />


                            <div className="d-flex justify-content-between align-items-center">



                            </div>

                        </div>






                    </div>


                </div>

            </div>
            <hr />
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-8" >


                            <img src={Reactjs} className="card-img-top" alt="Reactjs" />

                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <div className="col-md-5 mt-6" >

                            <h6 className="card-text"> <b>REACT JS</b></h6>
                            <p className="card-text">
                                React – A JavaScript library for building user interfaces
                                74.5% of developers recommend to use reactjs, it is one of the most loved frameworks. There are so many tools that help in web
                                and app development but among all only a few are preferred by the enterprises. Facebook's ReactJS is one of them.</p>


                            <div className="d-flex justify-content-between align-items-center">

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-8" >




                            <h6 className="card-text"> <b>NODE JS</b></h6>
                            <p className="card-text">Node.js® is a JavaScript runtime built on Chrome's V8 JavaScript engine.
                            </p>

                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <br />
                        <div className="col-md-6 mt-8" >

                            <img src={NodeJS} className="card-img-top" alt="NodeJS" />


                            <div className="d-flex justify-content-between align-items-center">



                            </div>

                        </div>






                    </div>


                </div>

            </div>
            <hr />
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-8" >


                            <img src={Firebase} className="card-img-top" alt="Firebase" />

                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <div className="col-md-5 mt-6" >

                            <h6 className="card-text"> <b>FIREBASE</b></h6>
                            <p className="card-text">
                                Google Firebase is a Google-backed application development software</p>


                            <div className="d-flex justify-content-between align-items-center">

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </>
    );
}

export default Coding;